export default "__VITE_ASSET__Do57R3gE__"